import React, { createContext, useReducer } from 'react';

import { ExportStatusEnum } from '../../utils/enums';

import { IColorPosition, IInitialContextType } from './types';

export const initialContext: IInitialContextType = {
  imgSrc: '',
  imagePalette: null,
  exportStatus: ExportStatusEnum.READY_TO_START,
  generatedPalette: null,
};

export type ACTION_TYPES =
  | 'RESET_VALUES'
  | 'UPDATE_PALETTE'
  | 'UPDATE_PALETTE_HISTORY'
  | 'UPLOAD_IMAGE'
  | 'UPDATE_EXPORT_STATUS'
  | 'UPDATE_CIRCLE_POSITION'
  | 'UPDATE_HISTORY';

function appReducer(
  state: IInitialContextType,
  action: {
    type: ACTION_TYPES;
    payload: { [key: string]: any } | null;
    historyIndex: number | null;
    circlePosition: IColorPosition | null;
  },
): IInitialContextType {
  switch (action.type) {
    case 'UPDATE_EXPORT_STATUS': {
      return { ...state, ...action.payload };
    }
    case 'UPLOAD_IMAGE': {
      return { ...state, ...action.payload };
    }
    case 'RESET_VALUES': {
      return { ...initialContext };
    }
    case 'UPDATE_PALETTE': {
      return { ...state, ...action.payload };
    }
    case 'UPDATE_HISTORY': {
      return {
        ...state,
        imagePalette: { ...state.imagePalette, historyIndex: action.historyIndex },
      };
    }
    case 'UPDATE_CIRCLE_POSITION': {
      const newPaletteDetails = state.imagePalette.paletteDetails.slice();
      newPaletteDetails[state.imagePalette.historyIndex].selectedColorPosition =
        action.circlePosition;
      return {
        ...state,
        imagePalette: { ...state.imagePalette, paletteDetails: newPaletteDetails },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export const AppContext = createContext<{
  state: IInitialContextType;
  dispatch: React.Dispatch<any>;
}>({ state: initialContext, dispatch: () => null });

export const AppProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialContext);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};
